import { render, staticRenderFns } from "./join-list.vue?vue&type=template&id=00c327fa&scoped=true"
import script from "./join-list.vue?vue&type=script&lang=js"
export * from "./join-list.vue?vue&type=script&lang=js"
import style0 from "./join-list.vue?vue&type=style&index=0&id=00c327fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c327fa",
  null
  
)

export default component.exports